import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="settings--ai-assistant"
export default class extends Controller {
  static targets = ["form", "dialog", "levels", "level"]

  connect() {
    this.committed = this.levelTargets.find((level) => level.checked) || this.levelTargets[0]
  }

  toggleEnabled(event) {
    if (event.target.checked) {
      this.levelsTarget.disabled = false
      this.selectLevel("product_help")
    } else {
      this.levelsTarget.disabled = true
    }

    this.submit()
  }

  chooseLevel(event) {
    const radio = event.target

    if (radio.value === "full_access") {
      this.restoreCommitted()
      this.dialogTarget.showModal()
      return
    }

    this.committed = radio
    this.submit()
  }

  confirmFullAccess(event) {
    event?.preventDefault()
    this.selectLevel("full_access")
    this.dialogTarget.close()
    this.submit()
  }

  cancelFullAccess(event) {
    event?.preventDefault()
    this.restoreCommitted()
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target !== this.dialogTarget) return

    this.cancelFullAccess(event)
  }

  selectLevel(value) {
    const radio = this.levelTargets.find((level) => level.value === value)
    if (!radio) return

    radio.checked = true
    this.committed = radio
  }

  restoreCommitted() {
    if (this.committed) this.committed.checked = true
  }

  submit() {
    this.formTarget.requestSubmit()
  }
}
